import type { UserRef, ScoringGuide } from "../types";

// ─── Shared Mapper Helpers ──────────────────────────────────────────────

export function toUserRef(
  raw: { id: string; firstName?: string; lastName?: string; avatarUrl?: string } | null | undefined,
): UserRef {
  if (!raw) return { id: "", name: "Unknown" };
  const name = [raw.firstName, raw.lastName].filter(Boolean).join(" ") || raw.id;
  return {
    id: raw.id,
    name,
    avatarUrl: raw.avatarUrl,
  };
}

export function toScoringGuide(
  raw: Record<string, string> | null | undefined,
): ScoringGuide {
  if (!raw) {
    return { level1: "", level2: "", level3: "", level4: "", level5: "" };
  }
  return {
    level1: raw.level1 ?? "",
    level2: raw.level2 ?? "",
    level3: raw.level3 ?? "",
    level4: raw.level4 ?? "",
    level5: raw.level5 ?? "",
  };
}
